import "./App.css";
import Recat, { Component } from "react";
//"https://api.themoviedb.org/3/discover/movie?api_key=fc98261f9ba54beefd1338f3207b722e&language=en-US&sort_by=popularity.desc&include_adult=false&include_video=false&page=1"

export default class App extends Component {
    render() {
        let content = new Array();
        let active = 1;
        let mas = new Array();
        let vote_rating = 0;
        let release_date = 0;
        async function getResponce() {
            let responce = await fetch(
                `https://api.themoviedb.org/3/discover/movie?api_key=fc98261f9ba54beefd1338f3207b722e&language=en-US&sort_by=popularity.desc&include_adult=false&include_video=false&page=${active}`
            );
            content = await responce.json();
            drawing(content);
            mas = content;
            document.getElementById(`btn-${active}`).id = "btnActive";
        }

        function drawing(arr) {
            let key;
            document.getElementById("posts").innerHTML = "";
            for (key = 0; key < 20; key++) {
                var li = document.createElement("div");
                li.innerHTML = `<div className="card">
      <div className=card-title>${arr.results[key].title}</div>
      <div id="tekst_sverhu_kartinki_sprava_1">
      <div class="tekst_sverhu_kartinki_sprava_2 ">
      <span>${arr.results[key].release_date}</span></div>
      <img src="https://dwweb.ru/__img/__img_rotate/more.png " alt="Картинка фильма" className="card-img"style="width: 300px">  
      <div class="tekst_sverhu_kartinki_sprava_1 ">
      <span>${arr.results[key].vote_average}</span>
      </div></div>
      </div></div>`;
                document.getElementById("posts").appendChild(li);
            }
            drawingButton();
        }

        function selectHower() {
            var select = document.getElementById("select_");
            var value = select.value;
            let key;
            let temp;

            if (value === "vote_rating") {
                vote_rating++;

                for (let i = 0; i < 20; i++) {
                    for (let j = 0; j < 20 - 1; j++) {
                        if (vote_rating % 2 != 0) {
                            if (
                                mas.results[j].vote_average > mas.results[j + 1].vote_average
                            ) {
                                temp = mas.results[j];
                                mas.results[j] = mas.results[j + 1];
                                mas.results[j + 1] = temp;
                            }
                        }
                        if (vote_rating % 2 == 0) {
                            if (
                                mas.results[j].vote_average < mas.results[j + 1].vote_average
                            ) {
                                temp = mas.results[j];
                                mas.results[j] = mas.results[j + 1];
                                mas.results[j + 1] = temp;
                            }
                        }
                    }
                }
                drawing(mas);
            }

            if (value === "release_date") {
                release_date++;

                for (let i = 0; i < 20; i++) {
                    for (let j = 0; j < 20 - 1; j++) {
                        if (release_date % 2 != 0) {
                            if (
                                mas.results[j].release_date > mas.results[j + 1].release_date
                            ) {
                                temp = mas.results[j];
                                mas.results[j] = mas.results[j + 1];
                                mas.results[j + 1] = temp;
                            }
                        }
                        if (release_date % 2 == 0) {
                            if (
                                mas.results[j].release_date < mas.results[j + 1].release_date
                            ) {
                                temp = mas.results[j];
                                mas.results[j] = mas.results[j + 1];
                                mas.results[j + 1] = temp;
                            }
                        }
                    }
                }
                drawing(mas);
            }

            if (value == "none") {
                getResponce();
            }
        }

        function drawingButton() {
            let k = 1;
            let max = 10;
            let oct = 4;
            active = Number.parseInt(active);
            document.getElementById("footer").innerHTML = "";

            let div = document.createElement("div");
            div.innerHTML = "";
            if (active != 1) {
                div.innerHTML += `<input  id=${"btn-prev"} type="button" value="prev" />`;
                div.innerHTML += `<input id=${"btn-" + 1} type="button" value=${1} />`;
            }
            if (active === 1) {
                for (let i = 1; i <= oct; i++) {
                    div.innerHTML += `<input id=${
            "btn-" + i
          } type="button" value=${i} />`;
                }
            }
            if (active > 1 && active < max - oct) {
                for (let i = active; i < active + oct; i++) {
                    div.innerHTML += `<input id=${
            "btn-" + i
          } type="button" value=${i} />`;
                }
            }
            if (active >= max - oct && active < max) {
                let vach = max - active;
                for (let i = active - (oct - vach); i < active + vach; i++) {
                    div.innerHTML += `<input id=${
            "btn-" + i
          } type="button" value=${i} />`;
                }
            }
            if (active === max) {
                for (let i = max - oct; i <= max; i++) {
                    div.innerHTML += `<input id=${
            "btn-" + i
          } type="button" value=${i} />`;
                }
            }
            if (active != max) {
                div.innerHTML += `<input id=${
          "btn-" + max
        } type="button" value=${max} />`;
                div.innerHTML += `<input id=${"btn-next"} type="button" value="next" />`;
            }
            document.getElementById("footer").appendChild(div);
        }

        function btnHower() {
            var button = document.querySelectorAll('#footer [type="button"]');
            for (var i = 0; i < button.length; i++) {
                button[i].addEventListener("click", raz, false);
            }
        }

        function raz() {
            let tmp = this.value;
            if (tmp == "next") {
                active += 1;
            } else if (tmp == "prev") {
                active -= 1;
            } else {
                active = tmp;
            }

            getResponce();
        }

        getResponce();

        return ( <
            >
            <
            div className = "header-filter" >
            <
            select id = "select_"
            onClick = { selectHower } >
            <
            option value = "none" > none < /option> <
            option value = "release_date" > release_date < /option> <
            option value = "vote_rating" > vote_rating < /option> <
            /select> <
            /div> <
            div className = "container" >
            <
            div id = "posts"
            className = "cards" > < /div> <
            /div>

            <
            div >
            <
            form id = "footer"
            className = "footer"
            onClick = { btnHower } > < /form> <
            /div> <
            />
        );
    }
}